import { DoctorResult, SanityDoctor } from '~types/sanity';
import bronzeBadge from '~images/Bronze Badge.png';
import silverBadge from '~images/Silver Badge.png';
import goldBadge from '~images/Gold Badge.png';
import { ReactComponent as InfoIconGray } from '~svg/icons/icon-info-gray.svg';
import { Box, Flex } from 'theme-ui';
import { Modal, ModalProps, Spacer } from 'voom-gatsby';
import { useState } from 'react';
import { DoctorSearchBadgeInfoModal } from '~sections/DoctorSearchBadgeInfoModal';
import { PINK } from 'voom-gatsby/src/themes/bunionplasty/colors';


interface SearchBadgeImageProps {
  doctor: SanityDoctor | DoctorResult;
  mobileView: boolean;
}

export const SearchBadgeImage = ({
  doctor,
  mobileView
}: SearchBadgeImageProps) => {
  const [showSearchBadgeInfoModal, setShowSearchBadgeInfoModal] = useState(false);
  const openSearchBadgeInfoModal = () => setShowSearchBadgeInfoModal(true);
  const closeSearchBadgeInfoModal = () => setShowSearchBadgeInfoModal(false);
  let badgeSrc = '';
  let badgeName = '';
  if (doctor.searchBadges.includes('Gold Badge')) {
    badgeSrc = goldBadge;
    badgeName = 'Gold';
  } else if (doctor.searchBadges.includes('Silver Badge')) {
    badgeSrc = silverBadge;
    badgeName = 'Silver';
  } else if (doctor.searchBadges.includes('Bronze Badge')) {
    badgeSrc = bronzeBadge;
    badgeName = 'Bronze';
  }

  return badgeSrc && (
    <div>
      <Flex sx={{
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <img src={badgeSrc} style={{ width: mobileView ? '16px' : '25px' }}></img>
        <Spacer space={2} direction={'horizontal'}></Spacer>
        <span sx={{ color: 'black', fontSize: ['12px', null, null, '18px'] }}>{badgeName} Experience</span>
        <Spacer space={1} direction={'horizontal'}></Spacer>
        <InfoIconGray onClick={(e: Event) => { setShowSearchBadgeInfoModal(true); e.preventDefault(); }} sx={{ width: 16, height: 16,
          ':hover *': {
            fill: PINK
          },
         }} />
      </Flex>
      <DoctorSearchBadgeInfoModal
        close={closeSearchBadgeInfoModal}
        open={openSearchBadgeInfoModal}
        isOpen={showSearchBadgeInfoModal}
      />
    </div>
  );
};
